import React from 'react';
import { Container, Typography } from '@mui/material';
import BackButton from '../../components/common/BackButton';

const AdminUsers = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <BackButton />
      
      <Typography 
        variant="h3" 
        sx={{ 
          mb: 4, 
          fontFamily: '"Playfair Display", serif',
          fontWeight: 600 
        }}
      >
        Gestión de Usuarios
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Página de gestión de usuarios en construcción...
      </Typography>
    </Container>
  );
};

export default AdminUsers; 